// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"523":"b7b72686","613":"8d649b06"}[chunkId] + ".chunk.js";
};